<template>
    <div class="sidebar">
        <el-menu
                class="sidebar-el-menu"
                :default-active="onRoutes"
                background-color="rgba(51,51,51,1)"
                active-text-color="#ffffff"
                text-color="rgba(255,255,255,0.8)"
                unique-opened
                router>
<!--            <div class="head-box"></div>-->
            <div  @click="collapseChage" class="collapse-btn">
                <i v-if="!collapse" class="el-icon-s-fold" style="color: deepskyblue;width: 50px;height: 50px" ></i>
                <i v-else class="el-icon-s-unfold" style="color: deepskyblue;width: 50px;height: 50px"></i>
            </div>
            <template v-for="item in result_list">
                <template v-if="item.children.length">
                    <el-submenu :index="item.urlAddress" :key="item.menuId">
                        <template slot="title">
               <!--             <el-image class="icon-img" :src="item.icon" :lazy='true'></el-image>-->
                            <span slot="title">{{ item.menuCaption }}</span>
                        </template>
                        <template v-for="sedItem in item.children">
                            <el-submenu
                                    v-if="sedItem.children.length"
                                    :index="sedItem.urlAddress"
                                    :key="sedItem.menuId">
                                <template slot="title">{{ sedItem.menuCaption }}</template>
                                <el-menu-item v-for="(threeItem,i) in sedItem.children"
                                        :key="i"
                                        :index="threeItem.urlAddress"
                                >{{ threeItem.menuCaption }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="sedItem.urlAddress" :key="sedItem.menuId">
                                {{ sedItem.menuCaption }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.urlAddress" :key="item.menuId">
<!--                        <el-image  class="icon-img" :src="item.icon" :lazy='true'></el-image>-->
                        <span slot="title">{{ item.menuCaption }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';

    export default {
        data() {
            return {
                active: '',
                breadcrumb: '',
                collapse: true,
                result_list: JSON.parse(localStorage.getItem('menus')),
            };
        },
        methods: {
            collapseChage() {
                this.collapse = !this.collapse;
                bus.$emit('collapse', this.collapse);
            }
            // handleSelect(key, keyPath) {
            //     console.log(key, keyPath);
            //     if(keyPath.length === 3) {
            //         for(let i=0; i<this.result_list.length; i++) {
            //             if(keyPath[0] === this.result_list[i].menuId) {
            //                 for(let j=0; j<this.result_list[i].length; j++) {
            //                     if()
            //                 }
            //             }
            //         }
            //     }
            // }
        },
        computed: {
            onRoutes(index) {
                this.active = index;
                return this.$route.path.replace('/', '');
            }
        },
        watch: {
            // // 获得面包屑
            // 'active.onRoutes':function () {
            //     for(let i=0; i<this.result_list.length; i++) {
            //         if(this.active.onRoutes === this.result_list[i].menuId) {
            //             this.breadcrumb = [this.result_list[i].menuCaption]
            //         }
            //         else if(this.result_list[i].children.length !==0 &&
            //             this.active.onRoutes !== this.result_list[i].menuId) {
            //             for(let j=0; j<this.result_list[i].children.length; j++) {
            //                 if(this.active.onRoutes === this.result_list[i].children[j].menuId) {
            //                     this.breadcrumb = [
            //                         this.result_list[i].menuCaption,
            //                         this.result_list[i].children[j].menuCaption
            //                     ]
            //                 }
            //             }
            //         }
            //     }
            // },
            breadcrumb:function () {
                bus.$emit('breadcrumb', this.breadcrumb);
            }
        },
        created() {
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
                bus.$emit('collapse-content', msg);
            });
        }
    };
</script>
<style>
    .is-active{
        background-color: rgba(97,167,255,1)!important;
        color: #FFFFFF!important;
    }
    .is-active:hover{
        background-color: rgba(97,167,255,1)!important;
        color: #FFFFFF!important;
    }
    .el-submenu__title:hover {
        background-color:rgba(51,51,51,1)!important;
         color:rgba(255,255,255,1) !important;
     }

</style>
<style scoped>
    .collapse-btn {
        padding: 0 21px;
        cursor: pointer;
        line-height: 70px;
    }
    /*.el-menu-item:hover{*/
    /*    background-color:rgba(51,51,51,1)!important;*/
    /*    color:rgba(255,255,255,1) !important;*/
    /*}*/

    .sidebar {
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        overflow-y: scroll;
    }
    .head-box {
        margin: 42px 74px;
        width:92px;
        height:92px;
        background:rgba(85,85,85,1);
        border:1px solid rgba(151,151,151,1);
    }
    .sidebar::-webkit-scrollbar {
        width: 0;
    }

    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 240px;
    }

    .sidebar > ul {
        height: 100%;
    }
    .icon-img {
        margin-right: 9px;
        position: relative;
        top: 19px;
    }
</style>
